import React from 'react';
import { TeamDto } from '../../../api/apis';

interface TeamSearchResultsProps {
  results: TeamDto[];
  onStopTeam: (teamId: string) => void;
  isLoading: boolean;
}

const TeamSearchResults: React.FC<TeamSearchResultsProps> = ({
  results,
  onStopTeam,
  isLoading,
}) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="max-h-[500px] overflow-y-auto">
        {results.map((team) => (
          <div
            key={team.id}
            className="p-3 hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="font-medium text-left">{team.name}</h3>
                <p className="text-sm text-gray-600 text-left">Category: {team.category}</p>
                <p className="text-sm text-gray-600 text-left">Members: {team.members.join(', ')}</p>
              </div>
              <button
                onClick={() => onStopTeam(team.id)}
                disabled={isLoading}
                className="bg-red-500 text-white py-1 px-3 rounded hover:bg-red-600 transition-colors disabled:opacity-50 text-sm ml-4"
              >
                {isLoading ? 'Stopping...' : 'Stop Team'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamSearchResults; 